import { createContext } from "react";
import useAttachmentsByProjectId from "../hooks/data/useAttachmentsByProjectId";

export interface IProjectAttachmentsContext extends ReturnType<typeof useAttachmentsByProjectId> {

};

const ProjectAttachmentsContext = createContext<IProjectAttachmentsContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default ProjectAttachmentsContext